import { Visible, Hidden, Stack, Inline } from '@leroy-merlin-br/backyard-react-ui'

import { Shell } from 'reactShared/components/Shell'

import { Widget } from '../Widget'
import * as S from './styled'

const ModulesLoading = ({ defaultFallback }) => {
  if (defaultFallback) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: defaultFallback
        }}
      />
    )
  }

  return (
    <Widget noTopSpacing>
      <Visible untilKilo kilo>

        <S.Module>
          <Shell height={200} />
        </S.Module>

        <S.Module>
          <Stack spacing="kilo">
            <Shell width={300} height={27} borderRadius="giga" />
            <Inline spacing="kilo" justify="left" noWrap>
              {Array(5).fill('').map((item, index) => <Shell key={index} width={125} height={125} borderRadius="giga" />)}
            </Inline>
          </Stack>
        </S.Module>

        <S.Module>
          <Stack spacing="kilo">
            <Shell width={300} height={27} borderRadius="giga" />
            <Shell height={200} />
            <Shell height={200} />
            <Shell height={200} />
          </Stack>
        </S.Module>
      </Visible>

      <Hidden untilKilo kilo>
        <S.Module>
          <Shell height={320} />
        </S.Module>

        <S.Module>
          <Stack spacing="kilo">
            <Shell width={300} height={27} borderRadius="giga" />
            <Inline spacing="mega" justify="left" noWrap>
              {Array(9).fill('').map((item, index) => <Shell key={index} width={125} height={125} borderRadius="giga" />)}
            </Inline>
          </Stack>
        </S.Module>

        <S.Module>
          <Stack spacing="kilo">
            <Shell width={300} height={27} borderRadius="giga" />
            <S.ThreeBanners>
              {Array(3).fill('').map((item, index) => <Shell key={index} height={320} />)}
            </S.ThreeBanners>
          </Stack>
        </S.Module>
      </Hidden>
    </Widget>
  )
}

export default ModulesLoading
